import { gql } from '@apollo/client';

const getInteressentById = gql`
  query ($variables: InteresentById!) {
    getInteresentById(input: $variables) {
      id
      name
      surname
      agent_id
      birthday
      is_male
      phone
      mobile
      email_private
      branch_office_id
      contract_type_id
      city
      address
      zip
      country_id
      notes
      converting
      interesentStatus {
        id
        title
        date
        checked
      }
    }
  }
`;

export default getInteressentById;
